import { render, staticRenderFns } from "./MenuGrid.vue?vue&type=template&id=7c229825&scoped=true&"
import script from "./MenuGrid.vue?vue&type=script&lang=js&"
export * from "./MenuGrid.vue?vue&type=script&lang=js&"
import style0 from "./MenuGrid.vue?vue&type=style&index=0&id=7c229825&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c229825",
  null
  
)

export default component.exports